import './SuccessScreen.css';
import { ReactComponent as SuccessMarkIcon } from "../../assets/icons/success-mark.svg";
import { getButtonTextColor } from "../../utils/cssVariables";
import { Button } from "@arco-design/web-react";
import classNames from 'classnames';
import { currentThemeName } from '../../theme';

type Props = {
  title: string;
  buttonText: string;
  onButtonClick: () => void;
}

export function SuccessScreen({ title, buttonText, onButtonClick }: Props) {
  return (
    <div className={classNames("success-screen", {
      "success-screen--black-theme": currentThemeName === 'black'
    })}>
      <h2 className="success-screen__title">{title}</h2>
      <SuccessMarkIcon className='success-screen__icon'/>
      <div className="success-screen__button-wrapper">
        <Button
          className="success-screen__button"
          size="large"
          shape={"round"}
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}